var exports = {
  "Qs": "xcc377c0b--4d521f--content",
  "J6": "xcc377c0b--4d521f--left-column",
  "wW": "xcc377c0b--4d521f--right-column",
  "fQ": "xcc377c0b--4d521f--content--top",
};

module.exports = exports;
